import { SystemBaseApi } from "./SystemBaseApi";
import { Methods } from '@newview/infrastructure';


export class EnterpriseprojectdatarelationApi extends SystemBaseApi {

  public get ControllerName(): any {
    return 'enterpriseprojectdatarelation'
  }

  /**
   * 查询列表
   * @param params
   * @returns 
   */
  public getListByParams(params) {
    return this.send(params, "getListByParams", Methods.GET)
  }
  
  /**
   * 子项目id查询企业列表
   * @param projectDataId 
   * @returns 
   */
  public getEnterPriseList(projectDataId){
    return this.send({projectDataId:projectDataId}, "getEnterPriseList", Methods.GET)
  }

}